import { PERMISSIONS, UserLike } from './permissions';

// Minimal "can" function
export function can(user: UserLike | null | undefined, permission: string): boolean {
  const role = user?.role;
  if (!role) return false;

  const allowedPermissions = PERMISSIONS[role];
  if (!allowedPermissions) return false;

  return allowedPermissions.includes(permission);
}
